import { FC } from 'react'
import {
  DropDownList,
  DropDownListChangeEvent,
  DropDownListProps,
  MultiSelect,
  MultiSelectChangeEvent,
  MultiSelectProps
} from '@progress/kendo-react-dropdowns'

import { useAppSelector } from '../../stores'
import { CodeName } from '../../services/initializing/CodeName'

interface OmittedDropDownListProps
  extends Omit<
  DropDownListProps,
  'data' | 'dataItemKey' | 'textField' | 'onChange'
  > {
  /** CODE */
  defaultValue?: string[]
  /** CODE */
  value?: string[]
}
interface OmittedMultiSelectProps
  extends Omit<
  MultiSelectProps,
  'data' | 'dataItemKey' | 'textField' | 'onChange'
  > {
  /** CODE */
  defaultValue?: string[]
  /** CODE */
  value?: string[]
}

type ProgressStatusSelectProps = {
  multiple?: boolean
} & OmittedMultiSelectProps &
OmittedDropDownListProps & {
  /**
     * @param value CODE List
     */
  onChange?: (valueList: string[]) => void
}

export const ProgressStatusSelect: FC<ProgressStatusSelectProps> = ({
  multiple = false,
  defaultValue,
  value,
  onChange,
  ...restProps
}) => {
  const common = useAppSelector((x) => x.common)
  const codeNames = common.initialData.codeNames('SI02')

  const createValue = (codeValueList?: string[]) => {
    if (!Array.isArray(codeValueList)) {
      return null
    }

    // 単一選択
    if (!multiple) {
      const value = codeNames.find(
        (codeName) => codeName.CODE === codeValueList[0]
      )

      return value === undefined ? null : value
    }

    // 複数選択
    if (multiple) {
      const _valueList = codeValueList.map<CodeName | undefined>(
        (codeValue) => {
          return codeNames.find((codeName) => codeName.CODE === codeValue)
        }
      )

      const valueList = _valueList.filter((value) => value !== undefined)

      return valueList
    }
  }

  const handleOnChange = (
    event: MultiSelectChangeEvent | DropDownListChangeEvent
  ) => {
    let value: string[] = []

    multiple
      // 複数選択
      ? (value = event.value.map((codeName: CodeName) => {
          return codeName.CODE
        }))
      // 単一選択
      : value.push(event.value.CODE)

    onChange?.(value)
  }

  return multiple
    ? (
    <MultiSelect
      {...restProps}
      data={codeNames}
      dataItemKey="CODE"
      textField="NAME"
      defaultValue={createValue(defaultValue) as string[]}
      value={createValue(value) as string[]}
      onChange={handleOnChange}
    />
      )
    : (
    <DropDownList
      {...restProps}
      data={codeNames}
      dataItemKey="CODE"
      textField="NAME"
      defaultValue={createValue(defaultValue)}
      value={createValue(value)}
      onChange={handleOnChange}
    />
      )
}
